import React, { useRef, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Toast } from "bootstrap";
import TaizoLogo from "../assets/images/Taizo.png";
import notificationSound from "../assets/audio/NotificationSound.mp3";
import { useDispatch } from "react-redux";
import { notiDetailsActions } from "../redux-store/store";
import CandidateCallRemainder from "../pages/Candidate/CandidateCallRemainder/CandidateCallRemainder";
import { MyModal } from "../utility";
import ModalContainer from "./modal_popup";

const CallRemainder_Alert = ({ triggerToast, onOpen, onClose }) => {
  const toastRef = useRef(null);
  const audioRef = useRef(null);
  const [opencallremainder, setopencallremainder] = useState(false);

  const handlePlayAudio = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((error) => {
        console.error("Audio playback failed:", error);
      });
    }
  };

  useEffect(() => {
    if (triggerToast) {
      const toastElement = new Toast(toastRef.current, { autohide: false });
      toastElement.show();
      handlePlayAudio();

      const closeTimeout = setTimeout(() => {
        if (onClose) onClose(); // Notify parent to close the alert
      }, 120000); // Close after 2 minutes

      return () => clearTimeout(closeTimeout);
    }
  }, [triggerToast, onClose]);

  const handleClose = () => {
    if (onClose) onClose(); // Notify parent when alert closes
  };

  const handleClickPage = () => {
    setopencallremainder(true); // Open the component
    const toastElement = Toast.getInstance(toastRef.current); // Get the existing toast instance
    toastElement.hide(); // Hide the toast
  };

  return (
    <>
      <div className="toast-container  position-fixed bottom-0 end-0 p-2 ">
        <div
          ref={toastRef}
          id="liveToast"
          className="toast"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="text-bg-dark rounded-1">
            <div className="toast-header text-bg-secondary">
              <strong className="me-auto">Notification</strong>
              <button
                type="button"
                className="btn-close text-light"
                data-bs-dismiss="toast"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="toast-body d-flex justify-content-between align-items-center">
              <div>Today's Call Remainder.</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  // marginTop: "-10px",
                }}
              >
                <button
                  onClick={handleClickPage}
                  style={{
                    backgroundColor: "#169c50",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                >
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
        <audio ref={audioRef} src={notificationSound} />
      </div>
      {opencallremainder && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <CandidateCallRemainder
                  onclose={() => setopencallremainder(false)}
                />
              </>
            }
          />
        </MyModal>
      )}
    </>
  );
};

export default CallRemainder_Alert;
